export const validateCoupons = (
  priceId: string,
  couponMetadata: any = {},
  productId?: string,
  couponSupportingProducts?: Array<string> | undefined,
  restrictions: any = {},
  finalPrice = 0
): string | undefined => {
  if (
    restrictions?.minimum_amount &&
    finalPrice * 100 < restrictions?.minimum_amount
  ) {
    return `This coupon is invalid for this subscription`;
  }

  // check if coupon is restricted to any specific product
  if (
    productId &&
    !!couponSupportingProducts?.length &&
    !couponSupportingProducts.includes(productId)
  ) {
    return 'This coupon is invalid for this subscription';
  }

  if (!couponMetadata.priceId) {
    return;
  }

  const priceIds = (couponMetadata?.priceId || '')
    .split(',')
    .map((c: string) => c.trim());
  // If the priceId is not in the metadata.priceIds list show error
  if (priceIds.includes(priceId) === false) {
    return (
      couponMetadata.priceIdError ||
      'This coupon is invalid for this subscription'
    );
  }
};
